<template>
  <div class="poster">
    <div class="poster-mask">
      <div class="poster-box" @click.stop="bindStop" v-show="showPoster">
        <div class="container">
          <div class="opacity">
            <div class="share-poster" ref="poster">
              <img
                class="share-image"
                @load="bindLoadImage"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_poster?cur=time"
                alt=""
              />
              <div class="qrcode">
                <canvas id="qrcode-canvas"></canvas>
              </div>
            </div>
          </div>
          <img class="poster-result" :src="imgUrl" />
        </div>
      </div>
    </div>
    <ShareComponent
      class="share-container"
      :shareType="shareType"
      @click="bindClick"
      @close="bindClose"
      :copyUrl="qrcodeUrl"
    />
  </div>
</template>
<script>
import ShareComponent from './share.vue'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
export default {
  components: {
    ShareComponent
  },
  props: {},
  data() {
    return {
      isLoadImage: false, //海报底图是否加载完成
      showPoster: false, //是否显示分享海报
      qrcodeUrl: 'http://wemain.gym2.com/planet-record/detail?curField=bmi', //海报二维码链接
      imgUrl: '', //图片base64资源
      isCreatePoster: false,
      inviteUrl: '', // 复制的链接
      shareType: 0 //分享类型  默认0是链接 1是分享图
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    init() {
      this.qrcodeUrl =
        location.protocol +
        '//' +
        location.hostname +
        '/camp-invite/invite?activityId=' +
        this.$parent.activityId +
        '&inviteId=' +
        this.$parent.inviteId
      console.log(this.qrcodeUrl)
    },
    //海报图片加载完成之后才能生成图片
    bindLoadImage() {
      console.log('图片加载完成')
      this.isLoadImage = true
    },
    //阻止冒泡事件
    bindStop() {},
    //点击分享组件中对应的按钮触发对应的事件
    bindClick(index, type) {
      if (type === 0) {
        switch (index) {
          case 0:
            this.bindShowPoster()
            break
          case 1:
            this.shareFriend(type)
            break
          case 2:
            this.shareWechatCicle(type)
            break
          case 3:
            break
        }
      } else if (type === 1) {
        switch (index) {
          case 0:
            this.handelSaveImg()
            break
          case 1:
            this.shareFriend(type)
            break
          case 2:
            this.shareWechatCicle(type)
            break
          case 3:
            break
        }
      }
    },
    bindClose() {
      this.$emit('close')
    },
    //分享到微信好友
    shareFriend(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc: '为你专属定制的减脂营养服务，立即免费领取',
            title: '吃饱也能瘦？专业营养师在线饮食指导',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_thumbnail' // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.imgUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc: '为你专属定制的减脂营养服务，立即免费领取',
            title: '吃饱也能瘦？专业营养师在线饮食指导',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_thumbnail' // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信朋友圈
    shareWechatCicle(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc: '为你专属定制的减脂营养服务，立即免费领取',
            title: '吃饱也能瘦？专业营养师在线饮食指导',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_thumbnail' // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.imgUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc: '为你专属定制的减脂营养服务，立即免费领取',
            title: '吃饱也能瘦？专业营养师在线饮食指导',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_thumbnail' // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信
    shareWechat(obj) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppShare(obj)
      }
    },
    bindShowPoster() {
      this.showPoster = true
      window.scrollTo(0, 0) //html2canvas插件问题必须滚动到顶部才能正常生成
      setTimeout(() => {
        this.creatQrcode()
      }, 100)
    },
    //生成二维码
    creatQrcode() {
      if (!this.isLoadImage) {
        this.$toast('海报图片暂未加载,请稍后再试')
        return
      }
      if (this.isCreatePoster) {
        return
      }
      this.$toast.loading('生成图片中...')
      this.imgUrl = ''
      this.isCreatePoster = true
      //计算出二维码的实际宽度
      let screenWidth = window.screen.width
      let designWidth = 375
      let designQrcodeWidth = 90
      let qrcodeWidth = (screenWidth * designQrcodeWidth) / designWidth
      setTimeout(() => {
        this.$nextTick(() => {
          // 合成分享图
          let canvas = document.getElementById('qrcode-canvas')
          QRCode.toCanvas(
            canvas,
            this.qrcodeUrl,
            { width: qrcodeWidth, height: qrcodeWidth },
            (error) => {
              if (error) {
                console.log(error)
                this.isCreatePoster = false
                this.$toast.clear()
                this.$toast('生成二维码失败')
              } else {
                this.$nextTick(() => {
                  this.creatPoster()
                })
              }
            }
          )
        })
      }, 100)
    },
    //生成海报
    creatPoster() {
      html2canvas(this.$refs.poster, {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          this.$toast.clear()
          this.imgUrl = canvas.toDataURL()
          this.$toast('图片已生成')
          this.shareType = 1
        })
        .catch((err) => {
          console.log(err)
          this.$toast.clear()
          this.$toast('生成图片失败')
        })
        .finally(() => {
          this.isCreatePoster = false
        })
    },
    //保存图片
    handelSaveImg() {
      console.log('保存到手机成功')
      if (this.$http._isApp()) {
        this.$betterwe.onAppSaveImage({
          data: this.imgUrl, //分享的具体数据
          //分享的数据的格式
          //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'base64'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.poster {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .poster-mask {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .poster-box {
    height: 100%;
    padding: 67px 32px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .container {
      width: 100%;
      position: relative;
      height: 100%;
    }
    .opacity {
      width: 100%;
      height: 100%;
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .poster-result {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 99;
      object-fit: contain;
    }
    .share-poster {
      display: inline-block;
      position: relative;
      .share-image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
      .qrcode {
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 90px;
        height: 90px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      #qrcode-canvas {
        width: 100%;
        height: 100%;
      }
    }
  }
  .share-container {
    width: 100%;
  }
}
</style>
